/** Takes the first letter of a string and capitalizes it */
export default function ucfirst(string: string): string {
	return string.charAt(0).toUpperCase() + string.slice(1);
}
